import type { TradingAssets } from "shared/model";

import styles from "./Tabs.module.css";

type Tab = {
  label: string;
  value: TradingAssets;
};

type Props = {
  tabs: Tab[];
  activeTab: TradingAssets | null;
  onSelect: (value: TradingAssets) => void;
};

export const Tabs: React.FC<Props> = ({ tabs, activeTab, onSelect }) => {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={
            activeTab === tab.value
              ? `${styles.tab} ${styles.activeTab}`
              : styles.tab
          }
          onClick={() => onSelect(tab.value)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
